import React from 'react';

import { convertFeetToInches, convertInchesToFeet } from '@paragon/geometry-library';

import { MultiValueDistanceInput, type MultiValueDistanceInputProps } from './MultiValueDistanceInput';

export function MultiValueFeetDistanceInput(props: MultiValueDistanceInputProps) {
  return (
    <MultiValueDistanceInput
      sx={props.sx}
      label={props.label}
      disabled={props.disabled}
      values={props.values.map(convertFeetToInches)}
      min={props.min !== undefined ? convertFeetToInches(props.min) : undefined}
      max={props.max !== undefined ? convertFeetToInches(props.max) : undefined}
      submit={(newValueInInches) => props.submit(convertInchesToFeet(newValueInInches))}
    />
  );
}
